import { render, staticRenderFns } from "./BbeeCalidadPD.vue?vue&type=template&id=712e9bc0"
import script from "./BbeeCalidadPD.vue?vue&type=script&lang=js"
export * from "./BbeeCalidadPD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports